module.exports = __webpack_public_path__ + "assets/images/ert_sports5.7fcf498f650ad81ab9601a6013069500.png";